import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IActoCondicionModel } from 'src/app/models/interfaces/acto-condicion/IActoCondicionModel';
import { IFilterActoCondicionModel } from 'src/app/models/interfaces/acto-condicion/IFilterActoCondicionModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ActoCondicionService {

  private configUrl = [environment.apiGatewayUrl, 'actos-condicion'].join('/');
  constructor(private http: HttpClient) { }

  getListFiltered(
    model: IFilterActoCondicionModel
    ) : Observable<SearchResultModel<IActoCondicionModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    queryParams.push(`idEstado=${model.idEstado}`);
    
    if (model.nombre !== '') {
      queryParams.push(`nombre=${model.nombre}`);
    }

    return this.http.get<SearchResultModel<IActoCondicionModel[]>>(
      `${this.configUrl}/filtrar?${queryParams.join('&')}`
    );
  }

  getAllList(
    model: IFilterActoCondicionModel
    ) : Observable<IActoCondicionModel[]> {
    let queryParams: string[] = new Array<string>();

    // queryParams.push(`page=${model.page}`);
    // queryParams.push(`take=${model.pageSize}`);

    return this.http.get<IActoCondicionModel[]>(
      `${this.configUrl}/all?${queryParams.join('&')}`
    );
  }

  getById(id: number): Observable<IActoCondicionModel> {
    return this.http.get<IActoCondicionModel>(`${this.configUrl}/${id}`);
  }

  submit(model: IActoCondicionModel) {
    return this.http.post<IActoCondicionModel>(`${this.configUrl}`, model);
  }

  update(model: IActoCondicionModel) {
    return this.http.put<IActoCondicionModel>(
      `${this.configUrl}/${model.idActoCondicion}`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<IActoCondicionModel>(`${this.configUrl}/${id}`);
  }
}
